import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { DownOutlined, PaperClipOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import ReactLoading from "react-loading";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import { createFormAttachment } from "../../Helpers/API/CheckUpApi/FormApi";
import { saveForm } from "../../Helpers/API/PatientApi/FormApi";
import { convertQuillToHtml } from "../../../Helpers/Utils/Common";
import { refreshPage } from "../../../Helpers/Utils/Common";
import { FORM } from "../../../Constants/doctor";
import medicine from "../../../Assets/Images/clinica-prime-logo-dark.png";

import "./Buttons.css";
function BtnPdf({
  size,
  divId,
  label,
  fileName,
  setFormPdf = (formPdf) => null,
  quill,
  formPdf,
  id,
  typeValue,
  paperType,
}) {
  const [isClicked, setIsClicked] = useState(false);
  const items = [
    {
      label: "A5",
      key: "a5",
      icon: <PaperClipOutlined />,
    },
    {
      label: "A4",
      key: "a4",
      icon: <PaperClipOutlined />,
    },
    {
      label: "Letter",
      key: "letter",
      icon: <PaperClipOutlined />,
    },
    {
      label: "Legal",
      key: "legal",
      icon: <PaperClipOutlined />,
    },
  ];

  // SAVE FORM CONTENTS
  async function handleSaveForm(paperType) {
    setIsClicked(true);
    var quillDelta = quill.getContents();
    var quillHtml = convertQuillToHtml(quillDelta);

    const response = await saveForm({
      patient_id: id,
      form_template_id: typeValue.value,
      content: quillHtml,
    });

    if (response.error) {
      response.error?.data?.messages.forEach((data) => {
        toast.error(data);
      });
    } else {
      toast.success(response.data.message, { autoClose: 1000 });
      handlePrint(response.data.form_id, paperType.key);
    }
    setFormPdf(null);
    setIsClicked(false);
  }

  // UPLOAD FILE TO PATIENT ATTACHMENTS
  async function handleUploadFile(formId, form_Pdf) {
    const response = await createFormAttachment(
      id, // patient id
      [{ file: form_Pdf }], // attachment
      typeValue.label, // form template label
      formId, // form id
      typeValue.value //form template id
    );
    if (response.error) {
      response.error?.data?.messages.map((data) => {
        return toast.error(data);
      });
    } else {
      toast.success(response.data.message, { autoClose: 1000 });
      setTimeout(() => {
        refreshPage();
      }, 3000);
    }
  }

  // const handlePrint = async (form_id, paper_type) => {
  //   const input = document.getElementById(divId || "antd-table-container");

  //   // Add built-in header to tempDiv
  //   const headerDiv = document.createElement("div");
  //   headerDiv.className = "header";
  //   headerDiv.style.border = "none";
  //   headerDiv.innerHTML = `
  //     <div class="d-flex row justify-content-center">
  //       <div class="col text-center">
  //         <div class="row w-full">
  //           <label>
  //             <h1>
  //               <img src="${medicine}" className="header-logo" alt="logo" />
  //             </h1>
  //           </label>
  //         </div>
  //       </div>
  //     </div>
  //     <hr/>
  //   `;

  //   // Create a wrapper for content and add padding to it
  //   const contentWrapper = document.createElement("div");
  //   contentWrapper.className = "content-wrapper";
  //   contentWrapper.style.marginLeft = "70px"; // Add margin ONLY to contents
  //   contentWrapper.style.marginRight = "70px"; // Add margin ONLY to contents
  //   while (input.firstChild) {
  //     contentWrapper.appendChild(input.firstChild);
  //   }

  //   input.appendChild(headerDiv);
  //   input.appendChild(contentWrapper);

  //   document.body.appendChild(input);
  //   input.style.border = "none";
  //   input.style.fontSize = "1rem";

  //   // Convert HTML to canvas
  //   html2canvas(input, { backgroundColor: null }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", paper_type, true);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();
  //     const imgWidth = canvas.width;
  //     const imgHeight = canvas.height;
  //     const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
  //     const imgX = (pdfWidth - imgWidth * ratio) / 2;
  //     const imgY = 5;

  //     pdf.addImage(imgData, "PNG", imgX, imgY, imgWidth * ratio, imgHeight * ratio);

  //     // Save pdf file locally
  //     pdf.save(fileName);
  //     pdf.autoPrint();
  //     pdf.output("dataurlnewwindow");

  //     // Convert the pdf file from Blob to File obj (needed for upload API)
  //     const blobPdf = pdf.output("blob");
  //     const formPdf = new File([blobPdf], `${fileName}`, { type: blobPdf.type });

  //     setFormPdf(() => formPdf);
  //     handleUploadFile(form_id, formPdf);
  //   });
  // };

  const handlePrint = async (form_id, paperType) => {
    const input = document.getElementById(divId || "antd-table-container");

    // Add built-in header to tempDiv
    const headerDiv = document.createElement("div");
    headerDiv.className = "header";
    headerDiv.style.border = "none";
    headerDiv.innerHTML = `
      <div class="d-flex row justify-content-center">
        <div class="row text-center">
          <div class="col w-full">
            <label>
              <h1>
                <img src="${medicine}" className="header-logo" alt="logo" />
              </h1>
            </label>
          </div>
        </div>
      </div>
      <hr/>
    `;

    // Create a wrapper for content and add padding to it
    const contentWrapper = document.createElement("div");
    contentWrapper.className = "content-wrapper";
    contentWrapper.style.marginLeft = "70px";
    contentWrapper.style.marginRight = "70px";
    while (input.firstChild) {
      contentWrapper.appendChild(input.firstChild);
    }

    input.appendChild(headerDiv);
    input.appendChild(contentWrapper);

    document.body.appendChild(input);
    input.style.border = "none";
    input.style.fontSize = "1rem";

    // Convert HTML to canvas
    html2canvas(input, { backgroundColor: null }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", paperType, true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 5;

      // **Add Bottom Rectangles with Gaps**
      const rectHeight = 8; // Height of the rectangles
      const gapSize = 2; // Size of the gaps
      const rectWidth = pdfWidth / 2 - gapSize / 2; // Adjusted width to account for middle gap

      // **Left Sky-Blue Rectangle**
      pdf.setFillColor(102, 240, 242); // Skyblue color
      pdf.rect(
        gapSize,
        pdfHeight - rectHeight,
        rectWidth - gapSize,
        rectHeight,
        "F"
      );

      // **Right Blue Rectangle**
      pdf.setFillColor(0, 102, 204); // Blue color
      const rectX = pdfWidth / 2 + gapSize / 2;
      const rectY = pdfHeight - rectHeight;
      pdf.rect(rectX, rectY, rectWidth, rectHeight, "F");

      // **Right-Angled Triangle Above the Blue Rectangle**
      const triangleHeight = 125;
      const x1 = rectX + rectWidth; // Rightmost corner of the rectangle (right angle here)
      const y1 = rectY; // Top of the blue rectangle
      const x2 = rectX; // Leftmost corner of the rectangle (base side)
      const y2 = rectY; // Same base level as x1
      const x3 = x1; // The right angle vertex (same x as x1)
      const y3 = rectY - triangleHeight; // Triangle tip (higher than the base)

      pdf.setFillColor(241, 250, 252); // color of the triangle
      pdf.triangle(x1, y1, x2, y2, x3, y3, "F");

      // Add the content after setting the rectangle and triangle (text, tables, etc.)
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );

      // Save pdf file locally
      // pdf.save(fileName);
      // pdf.autoPrint();
      pdf.output("dataurlnewwindow");

      // Convert the pdf file from Blob to File obj (needed for upload API)
      const blobPdf = pdf.output("blob");
      const formPdf = new File([blobPdf], `${fileName}`, {
        type: blobPdf.type,
      });

      setFormPdf(() => formPdf);
      handleUploadFile(form_id, formPdf);
    });
  };

  const menuProps = {
    items,
    onClick: (e) => handleSaveForm(e),
  };

  return (
    <Col className="mb-2">
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#2d6e5e" />
        </Button>
      ) : (
        <Button
          className="action-btn clear"
          size={size}
          onClick={() => handleSaveForm(paperType)}
        >
          {label || "Download PDF"}
        </Button>
        // <Dropdown menu={menuProps}>
        //   <Button className="action-btn clear" size={size}>
        //       {label || "Download PDF"}
        //       <DownOutlined />
        //   </Button>
        // </Dropdown>
      )}
    </Col>
  );
}

export default BtnPdf;
